class EmbedInstagramFeed {
  constructor(url, title, subtitle) {
    this.url = url || "";
    this.title = title || "Instagram Feed";
    this.subtitle = subtitle || "Check out our latest feed from instagram";
    this.data = [];
    this.apiError = null;
    this.getFeed();
  }

  async getFeed() {
    try {
      const res = await fetch(this.url);
      const ncapiResponse = await res.json();
      this.data = ncapiResponse.data;
      this.render();
    } catch (e) {
      this.apiError = true;
      console.error(e);
    }
  }

  render() {
    const container = document.getElementById("instagram-slick");
    if (this.url) {
      let htmlTemplate = this.data
        .map((item) => {
          if (item.media_type === "CAROUSEL_ALBUM") {
            return `
            <div>
            <div class="ig-item">
                <a target="_blank" rel="noopener" href="${item.permalink}">
                <img src="${item.media_url}" alt="${item.caption}" class="ig-item-img">
                <div class="nc-caption">${item.caption}</div>
                </a>
            </div>
            </div>
            `;
          }
          if (item.media_type === "IMAGE") {
            return `
            <div>
            <div class="ig-item">
                <a target="_blank" rel="noopener" href="${item.permalink}">
                <img src="${item.media_url}" alt="${item.caption}" class="ig-item-img">
                <div class="nc-caption">${item.caption}</div>
                </a>
            </div>
            </div>
            `;
          }
          if (item.media_type === "VIDEO") {
            return `
            <div>
            <div class="ig-item">
                <a target="_blank" rel="noopener" href="${item.permalink}">
                <img src="${item.thumbnail_url}" alt="${item.caption}" class="ig-item-img">
                <div class="nc-caption">${item.caption}</div>
                </a>
            </div>
            </div>
            `;
          }
        })
        .join("");
        container.innerHTML = htmlTemplate;
        $('#instagram-slick').slick({
          dots: false,
          draggable: true,
          infinite: false,
          speed: 300,
          slidesToShow: 2,
          slidesToScroll: 1,
          adaptiveHeight: false,
          autoplay: false,
          autoplaySpeed: 3000,
          arrows: true,
        });
      } else {
      container.innerHTML = "";
    }
  }
}

const instagramFeed = new EmbedInstagramFeed(
  //"https://v1.nocodeapi.com/tangents/instagram/vyIWdVuRUcLULSwc?limit=10",
  "https://graph.instagram.com/me/media?fields=media_count,media_type,permalink,media_url,caption,thumbnail_url&limit=10&access_token=IGQVJVNVpFMElsUC1pZAW1seGUwX0xIV0I3TjFMQk8wTEhmaE43bUJmOXJjYlVORVczS191S0VrcDJDOGZAiZAVh0QkljUDVKWU1oVkZADLUpOdlB2aEowVkVUQ2VQaVJWYmFWLXhnaXg4WXpRUDNRb1Y5agZDZD",
  "Instagram Feed",
  "Check out our latest feed from instagram"
);
